export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, setting } = this

	let arr = [
		{
			label: '派单公司',
			value: order.company,
		},
		// {
		// 	label: '所属险种',
		// 	value: setting.insuranceTypeMap[order.insuranceType],
		// },
		{
			label: '报案号',
			value: order.caseNo,
		},
		{
			label: '服务公司',
			value: order.serviceCompanyName,
		},
		{
			label: '订单号',
			value: order.orderNo,
		},
	]
	arr.push(
		{
			label: '任务类型',
			value: setting.surveryTasktypeMap[order.taskType],
		},
		// {
		// 	label: '订单类型',
		// 	value: setting.orderTypeMap[order.orderType],
		// },
		{
			label: '伤者/家属姓名',
			value: order.injuredName,
		}
	)
	if (order.injuredPhone) {
		const phone = order.injuredPhone.split(',')
		if (phone.length === 1) {
			arr.push({
				label: '伤者/家属电话',
				value: phone[0],
			})
		} else {
			for (const [index, item] of phone.entries()) {
				arr.push({
					label: `伤者/家属电话${index + 1}`,
					value: item,
				})
			}
		}
	} else {
		arr.push({
			label: '伤者/家属电话',
			value: order.injuredPhone,
		})
	}
	if (this.isWorkInvestigate) {
		arr.push(
			{
				label: '调查所在地区',
				value: order.clinicArea,
			},
			{
				label: '调查公司名称',
				value: order.injuredCompany,
			},
			{
				label: '公司详细地址',
				value: order.address,
			},
			{
				label: '所在岗位',
				value: order.injuredJob,
			}
		)
	}
	if (this.isLivingInvestigate) {
		arr.push(
			{
				label: '调查所在地区',
				value: order.clinicArea,
			},
			{
				label: '调查详细地址',
				value: order.address,
			}
		)
	}
	arr = arr.concat([
		{
			label: '案件负责人姓名',
			value: order.contact,
		},
		{
			label: '案件负责人电话',
			value: order.contactPhone,
		},
	])
	arr.push({
		label: '任务要求',
		value: order.visitRequest,
	})

	arr.push({
		label: '任务单证',
		value: order.mediaList || [],
		slot: 'mediaList',
	})
	if (order.cancelReason) {
		arr.push({
			label: '撤单原因',
			value: order.cancelReason,
		})
	}
	return {
		title: '任务信息',
		children: arr,
	}
}
